import React from "react";
import classNames from "classnames";
import { NumberInput } from "@wfp/ui";
import styles from "./style.module.scss";

export default function CompactNumberInput(props) {
  return (
    <NumberInput
      {...props}
      hideControls
      className={classNames(styles.input, props.className)}
    />
  );
}
